  <div class="container" [style.height.px]="height">
     <awc-table
      [isLoading]="loading"
      [columns]="columns"
      [rows]="rows"
      class="table"
     ></awc-table>
  </div>
